var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TimeScale"},_vm._l((_vm.timeBlocks),function(block,index){return _c('div',{key:index,staticClass:"Item",style:({
      flexBasis: `${block.duration * 3}px`,
      height: `${block.duration * 3}px`,
    })},[_c('div',{staticClass:"Label"},[_vm._v("\n      "+_vm._s(_vm.getTime(block.start))+"\n    ")]),_c('div',{staticClass:"Ruller"})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }